import { useRouterState } from "@tanstack/react-router"
import { useCallback } from "react"

import { useSkuStore } from "~/providers/sku-store-provider"
import { api } from "~/utils/api"
import { type ClientInteraction, measureInteraction } from "~/utils/clientPerf"

/** Starts measuring how long the page stays blocked after a user action, and logs it server-side. */
export function useMeasureInteraction() {
  const { mutate } = api.clientPerf.interaction.useMutation()
  const variantCount = useSkuStore((state) => state.variants.length)
  const route = useRouterState({ select: (state) => state.matches.at(-1)?.routeId ?? null })
  return useCallback(
    (interaction: ClientInteraction) =>
      measureInteraction((measurement) =>
        mutate({ interaction, variantCount, route, ...measurement }),
      ),
    [mutate, variantCount, route],
  )
}
